import { render } from "./IconBase.vue?vue&type=template&id=0be8999c&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import "./IconBase.vue?vue&type=style&index=0&id=0be8999c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be8999c"]])

export default __exports__